// 这个文件是用来添加临时多语言的

exports.addEn = {
    label: {
        title: 'hello'
    },
    tableHeader: {
        
    },
    button: {
        
    },
    tip: {
        
    },
    tabName: {
        
    },
}